import {
  IOrganisation,
  IQueryScopeRequests,
  isQueryScopeRequests,
} from '@principle-theorem/principle-core/interfaces';
import { isDocRef, TypeGuard } from '@principle-theorem/shared';
import { DocumentReference } from '@principle-theorem/shared';
import { isString } from 'lodash';

export interface IQueryScope {
  orgRef: DocumentReference<IOrganisation>;
  scopeRequests: IQueryScopeRequests;
  bigqueryDataset?: string;
}

export const isQueryScope = TypeGuard.interface<IQueryScope>({
  orgRef: isDocRef,
  scopeRequests: isQueryScopeRequests,
  bigqueryDataset: TypeGuard.nilOr(isString),
});
